import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_plus_circle",
  "use": "icon-icon_plus_circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_plus_circle\"><defs><style></style></defs><path d=\"M860.16 163.84a491.52 491.52 0 1 0 0 696.32 489.882 489.882 0 0 0 0-696.32zm-36.864 659.456a440.32 440.32 0 0 1-622.592-622.592 440.32 440.32 0 0 1 622.592 622.592z\" /><path d=\"M801.587 486.4H537.6V222.413a25.6 25.6 0 1 0-51.2 0V486.4H222.413a25.6 25.6 0 1 0 0 51.2H486.4v263.987a25.6 25.6 0 1 0 51.2 0V537.6h263.987a25.6 25.6 0 1 0 0-51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol